// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"568":"946d5250","855":"946d5250"}[chunkId] + ".chunk.css";
};